export const theBasics = 'the-basics'
export const lookAndFeel = 'look-and-feel'
export const advanced = 'advanced'
export const articleLookup = 'lookup'

export const HELP_SKILL_GATE = 'HELP_SKILL'